import { matchPath } from 'react-router-dom';

export const isCurrentRoute = (pathname: string, route: string): boolean => {
    const match = matchPath(pathname, { path: route, exact: true, strict: false });

    return !!match;
};

export const isCurrentIncludedPathInRoute = (pathname: string, route: string): boolean => {
    const match = matchPath(pathname, { path: route, exact: false, strict: false });

    return !!match;
};
